import React from 'react'

import IdeaImage from '../assets/idea.png'
import OutcomesImage from '../assets/outcomes.svg'
import ArrowImage from '../assets/outcomes-arrow.svg'

export const outcomes: string[] = [
  'In-depth Knowledge and Skills with real-time implementation',
  'Collaborative Project Experience and Teamwork',
  'Work Integrated Experience and an Impressive portfolio',
  'Interviews and Job offers from top tech companies'
]

const OutcomesSection = () => {
  return (
    <section className="bg-zinc-50">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:max-w-screen-2xl lg:px-8 space-y-24 py-12 w-full">
        <div className="lg:relative flex items-center justify-between gap-x-20">
          <img
            src={ArrowImage.src}
            className="w-18 h-24 mr-4 absolute -left-20 top-6 hidden lg:block"
            alt=""
          />

          <div className="lg:w-6/12 w-full">
            <h3 className="text-2xl md:text-3xl font-semibold mb-8">
              What You&apos;ll <span className="text-orange-500">Achieve</span>
            </h3>

            <ul className="flex flex-col gap-y-8">
              {outcomes.map((outcome, index) => (
                <div
                  key={index}
                  className="text-center p-4 bg-orange-100 shadow-md rounded-lg space-y-4">
                  <p className="text-base md:text-lg lg:text-xl">{outcome}</p>
                </div>
              ))}
            </ul>
          </div>

          <div className="hidden lg:block w-6/12 relative">
            <img
              src={IdeaImage.src}
              className="w-24 h-24 absolute -top-10"
              alt=""
            />
            <img src={OutcomesImage.src} alt="" />
          </div>
        </div>
      </div>
    </section>
  )
}

export default OutcomesSection
